import assign from 'lodash/assign';
import clone from 'lodash/clone';
import * as Base64 from 'js-base64';
import debug from 'debug';
import config from './config';
import { get, post } from './request';
import user from './user';
import storage from './storage';

import { getRandomString } from './utils';

const log = debug('felog');

function getBaseUrl() {
  return 'https://felog.memeyule.com/post';
}

const cacheKey = 'FELOG_USER_ID';
const CLIENT_ID = 'FELOG_CLIENT_ID';
let clientId = '';
let event_index = 0;

const defaultConfig = {
  app: `www.2339.com_v2${config.isElectron ? '_electron' : ''}`,
  app_version: config.version,
  env: config.mode,
  user_id: '',
  // level:'info',//  info warn error
  event: 'default',
  // event_type:'',
  desc: '', //  事件文字描述、备注
};

function init(opt: object = {}) {
  initClientId();
  assign(
    defaultConfig,
    {
      group_time: Date.now(),
      group_key: getRandomString(),
      client_id: clientId,
    },
    opt,
  );
  // @ts-ignore
  debug('log init', defaultConfig);
  registerEvent();
}

function initClientId() {
  clientId = storage.getItem(CLIENT_ID) || getRandomString(8);
  storage.setItem(CLIENT_ID, clientId);
}

function setExtraInfo(opt: object = {}) {
  assign(defaultConfig, opt);
}

function registerEvent() {
  // const listener = (e: any) => {
  //   let {target} = e;
  //
  //   for (let i = 0; i < 5; i++) {
  //     target = target.parentNode
  //     if (target && target.dataset && target.dataset.log) {
  //       console.log('log target',target,target.dataset.log)
  //     } else {
  //       return ;
  //     }
  //   }
  //
  // }
  //
  // if (document.addEventListener) {
  //   document.addEventListener('click', listener, true)
  // }
  // $('body').delegate('[data-log]', 'click', function () {
  //   var $this = $(this);
  //   var str = $this.data('log');
  //   var data = {};
  //   if (str.indexOf('=') > -1) {
  //     data = $.parseParam(str)
  //   } else {
  //     data = {
  //       event: str
  //     }
  //   }
  //   var defaultOpt = {
  //     event: $.trim($this.text()),
  //     desc: $.trim($this.text()).slice(0, 10),//,
  //     param: ''
  //   }
  //   data = _.assign(defaultOpt, data);
  //   send(data)
  // })
}

type Obj = {
  [property: string]: unknown;
};

type TrackErr = {
  err?: Obj;
  [property: string]: unknown;
};

type TrackData = {
  event: string;
  event_type?: string;
  content?: any;
  req_type?: string | object;
  req_opt?: string | object;
  req_time?: number | object;
  req_url?: string | object;
  [property: string]: unknown;
};

const parseError = (err: Obj): Obj => {
  if (err instanceof Error) {
    const { name, message } = err;
    return {
      name,
      message,
    };
  }
  return err;
};

/**
 *
 * @param data
 * {
 *     event,
 *     event_type,    ?
 *     param,
 *     desc
 * }
 * @private
 */
async function send(data: TrackData) {
  // if(data.param) {
  //     if(typeof data.param === 'object') {
  //         data.param_obj = JSON.stringify(data.param);
  //         delete data.param;
  //     }
  // }

  // if (!defaultConfig.user_id) {
  //   var userId = user.getUserId() + '';
  //   if (!userId) {
  //     userId = storage.getItem(cacheKey)
  //   }
  //   if (userId) {
  //     storage.setItem(cacheKey, userId);
  //     defaultConfig.user_id = userId
  //   }
  // }

  if (data.content) {
    if ((data.content as TrackErr).err) {
      (<TrackErr>data.content).err = parseError((data.content as TrackErr).err as Obj);
    }
    if ((data.content as TrackErr).error) {
      (<TrackErr>data.content).error = parseError((data.content as TrackErr).error as Obj);
    }
    data.content = JSON.stringify(parseError(data.content as Obj));
  }
  if (data.req_opt) {
    data.req_opt = JSON.stringify(data.req_opt);
  }

  const d = assign({}, defaultConfig, data, {
    user_id: `${user.getUserId()}`,
  });

  // @ts-ignore
  log('[felog]', JSON.stringify(d, ' ', 2));
  // if (!config.production) {
  //   return;
  // }
  event_index++;
  // @ts-ignore
  //
  // if (config.production) {
  post({
    url: getBaseUrl(),
    contentType: 'JSON',
    mode: 'no-cors',
    data: {
      event: d.event,
      event_type: d.event_type,
      event_index,
      data: Base64.encode(JSON.stringify(d)),
    },
  }).catch(() => {});
  // }
}

// 需要屏蔽的action
const blackActions = [
  'lian_mai_v2.timing_pk.pking',
  'lian_mai_v2.timing_pk_rank.pking',
  'multi_pk.pk_score',
];

const sendSocket = (type, msg, desc) => {
  let { action } = msg;
  const data = msg.data_d || msg.data;
  if (action.action) {
    action = `${action.module}.${action.action}`;
  }

  if (blackActions.includes(action)) {
    return;
  }

  // console.log('sendSocket', {
  //   action,
  //   data
  // })
  event_index++;
  send({
    event: 'socket',
    event_type: type,
    event_index,
    desc,
    socket: {
      action,
      content: JSON.stringify(data),
    },
  });
};

type Res = {
  msg?: string;
  message?: string;
};

function formatRes(res: Res) {
  if (res && res.msg && res.message) {
    const tem = clone(res);
    delete tem.message;
    return tem;
  }
  return res;
}

const getClientId = () => {
  if (!clientId) {
    initClientId();
  }
  return clientId;
};

const sendPageView = () => {
  send({
    event: 'page',
    event_type: 'pageView',
  });
};

const checkDelay = () => {
  const stime = Date.now();
  setTimeout(() => {
    const delay = Date.now() - stime;
    console.log('checkDelay', delay);
    if (delay > 20) {
      send({
        event: 'page',
        event_type: 'event_delay',
        delay,
      });
    }
  }, 0);
};

export default {
  init,
  send,
  sendSocket,
  setExtraInfo,
  formatRes,
  getClientId,
  sendPageView,
  checkDelay,
};
